import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import {Translate, translate} from 'views/module';

const ClientLeadEditStatus = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldStatus = oldData.status;
  const newStatus = newData.status;

  return (
    <Stack>
      <Translate
        expression='clientLead.ClientLeadDetail.Correspondance.Logs.EditStatus.Text'
        substitute={{
          oldStatus: translate(`clientLead.Status.${oldStatus}.Title`),
          newStatus: translate(`clientLead.Status.${newStatus}.Title`),
        }}
      />
    </Stack>
  );
};
ClientLeadEditStatus.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(ClientLeadEditStatus);
